import { ErrorPage } from '@tfl/component-library';

const PolicyNotFound = () => (
  <ErrorPage header="We can't find the page you're looking for" />
);

export default PolicyNotFound;
